import { Project } from '../../../../types/project'
import { formatDate } from '../../../../utils/numbersFormatting'

interface ProjectItemProps {
  project: Project
}

export default function ProjectItem({ project }: ProjectItemProps) {
  return (
    <div className="pb-8 border-b border-white-200 last:border-0">
      <h3 className="text-lg font-semibold text-white-900">{project.name}</h3>
      <p className="text-sm text-white-500 mb-2">
        {formatDate(project.startDate * 1000)} -{' '}
        {project.endDate ? formatDate(project.endDate * 1000) : 'Present'}
      </p>
      {project.description && (
        <p className="text-white-700">{project.description}</p>
      )}
    </div>
  )
}
